import placeholderImage from '../../public/images/placeholder-image.webp'

// Static import so the asset is served from /_next/static/media, which is routed to this app on every host
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
export const PLACEHOLDER_IMAGE = placeholderImage.src
